import React from 'react';
import ReactDOM from 'react-dom';
import MainApp from './MainApp';

import './index.css';

ReactDOM.render(
  <MainApp/>,
  document.getElementById('app-site')
);
